import { gql } from "@apollo/client";

export default gql`
  mutation updateAutoFormalizeInvoices($value: AutoFormalizeInvoicesPreference!){
    updateAutoFormalizeInvoices(value: $value){
        success
        data{
            requireAccountApproval
            autoFormalizeInvoices
        }
        code
        message
    }
}
`
